import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sendContactMessage } from '../api/contactApi';
import { useToast } from '../context/ToastContext';

const useContact = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const { addToast } = useToast();

    const submitContactForm = async (formData) => {
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const response = await sendContactMessage(formData);
            setSuccess(true);
            addToast(t('contact.messageSent'), 'success');
            return response;
        } catch (err) {
            const errorMessage = err.response?.data?.message || t('contact.messageFailed');
            setError(errorMessage);
            addToast(errorMessage, 'error');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const resetStates = () => {
        setLoading(false);
        setError(null);
        setSuccess(false);
    };

    return {
        loading,
        error,
        success,
        submitContactForm,
        resetStates
    };
};

export default useContact;